import { permissionsHelper } from '@/helpers/permissions.helper';
import { globalSettingsHelper } from '@/helpers/settings-helper';

class BusinessHelper {
  get isAllowedToViewInvitations(): boolean {
    return !globalSettingsHelper.isRegistrationByAdminMode;
  }

  get isAllowedToViewOrganisationInvitations(): boolean {
    return permissionsHelper.isAllowedToViewOrganisationInvitations && !globalSettingsHelper.isRegistrationByAdminMode;
  }

  get isAdminAllowedToViewOrganisationInvitations(): boolean {
    return permissionsHelper.isAdminAllowedToViewOrganisationInvitations && !globalSettingsHelper.isRegistrationByAdminMode;
  }

  get isAllowedToViewMyOrganisations(): boolean {
    return permissionsHelper.isAllowedToViewMyOrganisations && !globalSettingsHelper.isRegistrationByAdminMode;
  }

  get isAllowedToImportOrganisations(): boolean {
    return globalSettingsHelper.isMOSystem && globalSettingsHelper.isRegistrationByAdminMode && permissionsHelper.isAdminAllowedToImportOrganisations;
  }

  get isAllowedToAddOrganisationUser(): boolean {
    return globalSettingsHelper.isMOSystem && globalSettingsHelper.isRegistrationByAdminMode && permissionsHelper.isAdminAllowedToAddOrganisationUser;
  }

  get isAllowedToTransferOrganisationUser(): boolean {
    return globalSettingsHelper.isMOSystem && globalSettingsHelper.isRegistrationByAdminMode && permissionsHelper.isAdminAllowedToTransferOrganisationUser;
  }

  get isAllowedToChangeOrgName(): boolean {
    return globalSettingsHelper.isMOSystem && permissionsHelper.isAdminAllowedToChangeOrgName;
  }

  get isAllowedToDelMultipleOrganisations(): boolean {
    return globalSettingsHelper.isMOSystem && permissionsHelper.isAdminAllowedToDelClient;
  }

  get isAllowedToSendMultipleRegCompletionLetters(): boolean {
    return globalSettingsHelper.isMOSystem;
  }

  get isCoverLetterEnabled(): boolean {
    return !globalSettingsHelper.isMOSystem;
  }

  get isHidingUserPersonalInfoEnabled(): boolean {
    return !globalSettingsHelper.isMOSystem;
  }

  get isAccessToDocumentViaUrlEnabled(): boolean {
    return !globalSettingsHelper.isMOSystem;
  }
}

export const businessHelper: BusinessHelper = new BusinessHelper();
